module.exports = __webpack_public_path__ + "assets/fonts/glyphicons-halflings-regular.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.eot
 ** module id = 339
 ** module chunks = 0
 **/